module.exports = __webpack_public_path__ + "img/7.a47e9508.jpg";